import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';

import accountManIcon from 'assets/img/icons/account-man.svg';
import profileIcon from 'assets/img/icons/profile.svg';
import { useLocation } from 'react-router-dom';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import { authSelector } from 'selectors/modules/auth';
import { AuthStatus } from 'slices/modules/auth/authState';
import { ReactElement, useEffect } from 'react';
import { Image } from '@chakra-ui/react';
import { useLazyFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

interface SiteNavItem {
  title: string;
  href: string;
  extra?: ReactElement;
  isActive?: boolean;
}

export const getWebSiteUrl = (path: string): string => {
  const siteUrl = process.env['REACT_APP_SHARESPRO_SITE'] ?? '';

  return `${siteUrl}${siteUrl.endsWith('/') ? '' : '/'}${path}`;
};

const useSiteNavItems = (): SiteNavItem[] => {
  const { t } = useTranslation();

  const location = useLocation();

  const isCommunityActive = location.pathname.startsWith(AppRoute.communityPath);
  const isAnyLinkActive = isCommunityActive;

  const authState = useAppSelector(authSelector);

  const [fetchProfile, { data: profileData }] = useLazyFetchProfileQuery();

  useEffect(() => {
    if (authState.status === AuthStatus.LoggedIn) {
      fetchProfile();
    }
  }, [authState.status]);

  let accountIcon;
  let accountName;
  if (authState.status === AuthStatus.LoggedIn) {
    let fullName: string = profileData?.firstName ?? '';
    if (fullName.length === 0) {
      fullName = profileData?.lastName ?? '';
    } else if (profileData?.lastName) {
      fullName += ` ${profileData?.lastName}`;
    }
    if (fullName.trim()) {
      accountName = fullName;
    } else {
      accountName = t('myAccount');
    }

    if (profileData?.avatar) {
      accountIcon = <Image w="30px" h="30px" borderRadius="50%" src={profileData?.avatar}/>;
    } else {
      accountIcon = <Image w="30px" h="30px" borderRadius="50%" src={profileIcon}/>;
    }
  } else {
    accountIcon = <Image src={accountManIcon} height="20px" />;
    accountName = t('navAccount');
  }

  return [
    {
      title: t('strategiesTitle'),
      href: getWebSiteUrl('#chart'),
    },
    {
      title: t('navServices'),
      href: getWebSiteUrl('#services'),
    },
    {
      title: t('navMediaPortal'),
      href: getWebSiteUrl('media'),
    },
    {
      title: accountName,
      href: AppRoute.portfolio,
      extra: accountIcon,
      isActive: !isAnyLinkActive,
    },
  ];
};

export default useSiteNavItems;
